import { InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> { }

export function InputsInfosPages({ ...rest }: InputProps) {
  return <input type='text' className="header-fields-item-input" style={{ width: '100%' }} {...rest} />
}

export function InputsInfosFields({ ...rest }: InputProps) {
  return <input type='text' className="bg-form-fields-content" {...rest} />
}

export function InputsInfosGroups({ ...rest }: InputProps) {
  return <input type='text' className="bg-form-fields-content"  {...rest} />
}